/* globals jQuery, BLOOMBERG */
/* eslint-disable @wordpress/no-global-active-element */

/**
 * External dependencies
 */
import CliboardJS from 'clipboard';

/**
 * Internal dependencies
 */
import { getFlagClass, setFlagClass } from './theme/flag-class';
import delegateEventListener from './theme/delegate-event';
import determineTarget from './theme/determine-target';
import toggleElement from './theme/toggle-element';
import setupTabs from './theme/tabs';
import setupAccordions from './theme/accordions';
import setupModals from './theme/modals';
import setupCarousels from './theme/carousels';
import setupDropdowns from './theme/dropdown';
import setupShareButtons from './theme/share-button';
import setupDirectoryModules from './theme/ajax-directory';

jQuery( $ => {
	// =========================
	// ! Flag Interaction Method
	// =========================

	function flagMouseUse() {
		document.body.classList.add( 'using-mouse' );
		document.body.classList.remove( 'using-keyboard' );
	}
	document.addEventListener( 'mousemove', flagMouseUse );
	document.addEventListener( 'touchstart', flagMouseUse );
	document.addEventListener( 'keydown', event => {
		if ( event.key === 'Tab' ) {
			document.body.classList.remove( 'using-mouse' );
			document.body.classList.add( 'using-keyboard' );
		}
	} );

	// =========================
	// ! External Link Mandate
	// =========================

	document.querySelectorAll( 'a[href^="http"]' ).forEach( anchor => {
		if ( ! anchor.target && ( ! anchor.href.startsWith( window.location.origin ) || anchor.href.endsWith( '.pdf' ) ) ) {
			anchor.setAttribute( 'target', '_blank' );
			anchor.setAttribute( 'rel', 'noreferrer noopener' );
		}
	} );

	// =========================
	// ! Basic Toggles
	// =========================

	delegateEventListener( 'click', '.js-toggle', ( event, trigger ) => {
		const target = determineTarget( trigger );
		if ( target ) {
			event.preventDefault();
			const isOpen = toggleElement( target, null, 'focus' );

			// For global styling that might be needed
			document.body.classList.toggle( `show-${ target.id }`, isOpen );
		}
	} );

	delegateEventListener( 'click', '.js-close', ( event, trigger ) => {
		event.preventDefault();
		toggleElement( trigger.closest( '[aria-hidden="false"]' ), false );
	} );

	// =========================
	// ! Menu Toggles
	// =========================

	const header = document.querySelector( '.bloomberg-header' );
	const navButtons = header.querySelectorAll( '.menu-item-object-supernav_menu > .menu-item-label' );
	const navFlyouts = document.querySelectorAll( '.bloomberg-flyout' );
	const menuToggle = header.querySelector( '.bloomberg-header__menu-toggle' );
	const returnButtons = document.querySelectorAll( '.bloomberg-flyout__return-button ' );

	// Store initial colorscheme for header
	const headerColor = getFlagClass( header, 'has-colorscheme' );
	const headerMode = getFlagClass( header, 'with-colorscheme' );

	function resetColors() {
		setFlagClass( header, 'has-colorscheme', headerColor );
		setFlagClass( header, 'with-colorscheme', headerMode );
	}

	navFlyouts.forEach( flyout => {
		flyout.setAttribute( 'aria-hidden', true );
	} );

	navButtons.forEach( button => {
		button.setAttribute( 'aria-selected', false );

		button.addEventListener( 'click', () => {
			const target = determineTarget( button );
			const isOpen = toggleElement( target, null );

			navFlyouts.forEach( _flyout => {
				if ( _flyout.getAttribute( 'aria-hidden' ) === 'false' && _flyout !== target ) {
					toggleElement( _flyout, false );
				}
			} );

			let color = headerColor;
			let mode = headerMode;
			if ( isOpen ) {
				color = getFlagClass( target, 'has-colorscheme' );
				mode = getFlagClass( target, 'with-colorscheme' );
			}

			setFlagClass( header, 'has-colorscheme', color );
			setFlagClass( header, 'with-colorscheme', mode );
		} );
	} );

	menuToggle.addEventListener( 'click', () => {
		resetColors();
		navFlyouts.forEach( flyout => {
			toggleElement( flyout, false );
		} );
	} );

	returnButtons.forEach( button => {
		button.addEventListener( 'click', () => {
			resetColors();
		} );
	} );

	// =========================
	// ! Modals
	// =========================

	// Add classes to modals automatically
	$( '.bloomberg-modal' ).addClass( 'js-modal' );
	$( '.bloomberg-modal__close' ).addClass( 'js-modal-close' );
	$( '.bloomberg-modal__frame' ).addClass( 'js-modal-backdrop' );

	// Move all modals to root of body
	$( '.bloomberg-modal' ).appendTo( document.body );

	setupModals();

	// =========================
	// ! Mobile Sticky Page Nav Handling
	// =========================

	$( '.has-sticky-pagenav .bloomberg-pagenav__menu button' ).click( function() {
		toggleElement( this.closest( '[aria-hidden="false"]' ), false );
		document.body.classList.remove( 'show-pagenav' );
	} );

	// =========================
	// ! Tab Set
	// =========================

	// Add classes to tab/tabset blocks automatically
	$( '.bloomberg-tab-set' ).addClass( 'js-tab-set' );
	$( '.bloomberg-tab-set__nav-item' ).addClass( 'js-tab' );
	$( '.bloomberg-tab-panel' ).addClass( 'js-tab-panel' );

	// Mark first tab as auto-open accordion
	$( '.bloomberg-tab-set' ).each( function() {
		$( this ).find( '.bloomberg-tab-header__toggle' ).first().addClass( 'auto-open' );
	} );

	setupTabs();

	// =========================
	// ! Accordion
	// =========================

	// Group adjacent accordions
	$( '.bloomberg-accordion' ).each( function() {
		let $group = $( this ).prev( '.bloomberg-accordion-group' );
		if ( $group.length === 0 ) {
			$group = $( '<div class="bloomberg-accordion-group"></div>' );
			$group.insertBefore( this );
		}

		$( this ).appendTo( $group );
	} );

	// Add classes to accordion blocks automatically
	$( '.bloomberg-accordion-group' ).addClass( 'js-accordion-group' );
	$( '.bloomberg-accordion__toggle' ).addClass( 'js-accordion-toggle' );
	$( '.bloomberg-accordion__content' ).addClass( 'js-accordion-content' );

	setupAccordions( BLOOMBERG.accordionEndpoints || [] );

	// =========================
	// ! Gallery Carousels
	// =========================

	// Prep carousels for functionality
	$( '.bloomberg-carousel' ).each( function() {
		$( this ).addClass( 'js-carousel' );
		$( this ).find( '.bloomberg-carousel__slides' ).addClass( 'js-carousel-track' )
			.children().addClass( 'js-carousel-slide' );
		$( this ).find( '.bloomberg-carousel__pagination' ).addClass( 'js-carousel-pagination' );
	} );
	$( '.bloomberg-banner-carousel' ).each( function() {
		$( this ).addClass( 'js-carousel' );
		$( this ).find( '.bloomberg-banner-carousel__slides' ).addClass( 'js-carousel-track' )
			.children().addClass( 'js-carousel-slide' );
		$( this ).find( '.bloomberg-banner-carousel__pagination' ).addClass( 'js-carousel-pagination' );
	} );

	setupCarousels( { animate: true } );

	// =========================
	// ! Scroller Buttons
	// =========================

	function makeScrollerButton( type ) {
		const button = document.createElement( 'div' );
		button.className = `bloomberg-scroller__button ${ type }`;
		button.setAttribute( 'aria-hidden', true );
		return button;
	}

	document.querySelectorAll( '.bloomberg-scroller' ).forEach( scroller => {
		const inner = scroller.querySelector( '.bloomberg-scroller__inner' );
		const scrollerHeader = scroller.querySelector( '.bloomberg-scroller__header' );
		const nav = document.createElement( 'div' );
		nav.classList.add( 'bloomberg-scroller__nav' );
		scrollerHeader.append( nav );

		const nextButton = makeScrollerButton( 'next' );
		const prevButton = makeScrollerButton( 'prev' );
		const buttons = [ nextButton, prevButton ];

		nav.append( nextButton, prevButton );

		prevButton.hidden = true;
		inner.addEventListener( 'scroll', () => {
			nextButton.hidden = inner.scrollLeft + inner.offsetWidth >= inner.scrollWidth;
			prevButton.hidden = inner.scrollLeft === 0;
		} );

		buttons.forEach( button => {
			button.addEventListener( 'click', () => {
				if ( button.classList.contains( 'next' ) ) {
					inner.scrollBy( {
						left: scrollerHeader.offsetWidth,
					} );
				} else {
					inner.scrollBy( {
						left: -1 * scrollerHeader.offsetWidth,
					} );
				}
			} );
		} );
	} );

	document.addEventListener( 'keyup', event => {
		if ( event.key === 'Tab' ) {
			const scroller = document.activeElement?.closest( '.bloomberg-scroller__inner' );
			if ( scroller ) {
				document.activeElement.scrollIntoView( {
					block: 'nearest',
					inline: 'nearest',
				} );
			}
		}
	} );

	if ( typeof ResizeObserver !== 'undefined' ) {
		function checkScrollability( container ) {
			const parent = container.closest( '.bloomberg-scroller' );
			$( parent ).toggleClass( 'is-scrollable', container.scrollWidth > parent.offsetWidth );
		}

		const scrollerOberver = new ResizeObserver( entries => {
			entries.forEach( ( { target } ) => {
				checkScrollability( target );
			} );
		} );

		$( '.bloomberg-scroller__inner' ).each( function() {
			checkScrollability( this );
			scrollerOberver.observe( this );
		} );
	}

	// =========================
	// ! Toplinks
	// =========================

	if ( typeof IntersectionObserver !== 'undefined' ) {
		const toplinksByTarget = new WeakMap();

		const navObserver = new IntersectionObserver( ( [ entry ] ) => {
			const toplink = toplinksByTarget.get( entry.target );
			if ( toplink ) {
				toplink.classList.toggle( 'show', ! entry.isIntersecting );
			}
		}, {
			rootMargin: '-70px 0% 0% 0%',
		} );

		$( '.bloomberg-toplink' ).each( function() {
			const link = this.querySelector( 'a' );
			let target = link.getAttribute( 'href' );
			if ( target.length <= 1 ) {
				return;
			}

			target = document.querySelector( target );
			if ( ! target ) {
				return;
			}

			toplinksByTarget.set( target, this );
			navObserver.observe( target );
		} );
	}

	// =========================
	// ! Dropdown
	// =========================

	$( '.gfield:has(.ginput_container_select)' ).addClass( 'js-dropdown' );

	setupDropdowns();

	// =========================
	// ! Excerpt Handling
	// =========================

	$( document ).on( 'click', '.js-expand', function() {
		const expanded = $( this ).closest( '.is-expandable' ).toggleClass( 'is-expanded' ).hasClass( 'is-expanded' );

		// Swap the text with the cached label
		const label = $( this ).data( 'label' ) || ( expanded ? 'Show less' : 'Show more' );
		$( this ).data( 'label', $( this ).text() );
		$( this ).text( label );
	} );

	// =========================
	// ! Hidden Target Handling
	// =========================

	function handleHiddenTarget( event ) {
		// Get the target element
		const target = document.getElementById( window.location.hash.substring( 1 ) );
		if ( ! target ) {
			return;
		}

		// If it's an accordion, open it
		if ( target.classList.contains( 'bloomberg-accordion' ) ) {
			toggleElement( target.querySelector( '.js-accordion-content' ) );
			return;
		}

		// See if it's within a hidden container
		const container = target.closest( '[id][aria-hidden="true"]' );
		if ( ! container ) {
			return;
		}

		// Find the control for the container
		const control = document.querySelector( `[aria-controls=${ container.id }]` );
		if ( ! control ) {
			return;
		}

		// Prevent automatic scolling
		if ( event ) {
			event.preventDefault();
		}

		// Open the container and focus
		control.click();
		target.scrollIntoView();
	}

	window.addEventListener( 'hashchange', handleHiddenTarget );
	handleHiddenTarget();

	// =========================
	// ! Bookmark/Share Links
	// =========================

	setupShareButtons();

	$( 'a.js-clipboard' ).on( 'click', e => e.preventDefault() );

	const hrefClipboard = new CliboardJS( 'a.js-clipboard', {
		text( trigger ) {
			return trigger.getAttribute( 'href' );
		},
	} );

	const clipboardTooltipTimeouts = new WeakMap();
	hrefClipboard.on( 'success', e => {
		clearTimeout( clipboardTooltipTimeouts.get( e.trigger ) );
		$( e.trigger ).addClass( 'js-copied' ).attr( 'aria-label', 'Link copied!' );
		const timeout = setTimeout( () => $( e.trigger ).removeClass( 'js-copied' ), 5000 );
		clipboardTooltipTimeouts.set( e.trigger, timeout );
	} );

	// =========================
	// ! Directory Module
	// =========================

	setupDirectoryModules();

	// =========================
	// ! Search Flyout
	// =========================

	$( '.js-search' ).each( function() {
		const searchUrl = this.dataset.searchUrl;
		const $container = $( this );
		const $results = $container.find( '.js-search-results' );

		if ( $results.length === 0 ) {
			return;
		}

		const $form = $container.find( '.js-search-form' );
		const $input = $container.find( '.js-search-input' );
		const $suggestions = $container.find( '.js-search-suggestion' );
		const $more = $container.find( '.js-search-more' );
		const $query = $container.find( '.js-search-query' );
		const $noResults = $container.find( '.js-search-no-results' );

		$suggestions.on( 'click', function() {
			$input.val( this.value );
			$form.submit();
		} );

		$form.on( 'submit', function( e ) {
			e.preventDefault();
			$container.addClass( 'loading' );

			$noResults.attr( 'aria-hidden', true );
			$query.text( $input.val() );

			$.ajax( {
				url: searchUrl,
				data: { search: $input.val() },
				success( { url, results } ) {
					$container.addClass( 'has-results' );
					$more.attr( 'href', url );

					$results.empty().append( results );
					$noResults.attr( 'aria-hidden', results.length > 0 );
				},
				error() {
					$more.attr( 'href', null );

					$results.empty();
					$noResults.attr( 'aria-hidden', false );
				},
				complete() {
					$container.removeClass( 'loading' );
					$results.fadeIn();
				},
			} );
		} );
	} );

	// =========================
	// ! Excerpt Handling
	// =========================

	$( document ).on( 'click', '.bloomberg-excerpt__toggle', function() {
		$( this ).parents( '.bloomberg-excerpt' ).toggleClass( 'show-details' );
	} );
} );
